"use strict";
'use es6';
/*
 * Note - this interface is intended only to
 * encapsulate debug log + error message formatting.
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventError = exports.configError = exports.genericError = exports.debugLog = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var prettyPrint = function prettyPrint(str) {
  var cleaned = str.replace(/-/g, ' ');
  cleaned = cleaned.replace(/_/g, ' ');
  return cleaned.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var createLog = function createLog(type, name, message) {
  return "\nusage-tracker " + type + ": \"" + name + "\"\n----------------------------------------\n" + message + "\n";
};

var debugLog = function debugLog(name, _ref) {
  var eventKey = _ref.eventKey,
      eventName = _ref.eventName,
      eventNamespace = _ref.eventNamespace;
  var eventType = "[" + prettyPrint(eventNamespace) + "] " + prettyPrint(eventName);
  var messages = {
    eventKey: eventKey,
    eventType: eventType
  };
  return createLog('debug log', name, Object.keys(messages).reduce(function (accumulator, key) {
    var value = messages[key];

    if (typeof value === 'string') {
      accumulator += key + ": " + value + "\n";
    } else if ((0, _typeof2.default)(value) === 'object') {
      accumulator += key + ": " + JSON.stringify(value, null, 2) + "\n";
    } else {
      accumulator += key + ": " + (0, _typeof2.default)(value) + "\n";
    }

    return accumulator;
  }, ''));
};

exports.debugLog = debugLog;

var genericError = function genericError(message) {
  return new Error("usage-tracker error: " + message);
};

exports.genericError = genericError;

var configError = function configError(message) {
  return new Error("usage-tracker config error: " + message);
};

exports.configError = configError;

var eventError = function eventError(message) {
  return new Error("usage-tracker event error: " + message);
};

exports.eventError = eventError;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.376/js/common/messages.js
// module id = 49
// module chunks = 0